(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-footer.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-footer.js'); 'use strict';

svs.maltipset.views.BetslipFooter = Backbone.Marionette.View.extend({
  template: function template(data) {
    return svs.maltipset.templates.betslip_footer(data);
  },
  className: 'betslip-footer-maltipset',
  modelEvents: {
    'change:totalCost': 'onChange',
    'change:system': 'onChange',
    'change:totalCompleteRows': 'onChange',
    'change:numWeeks': 'onChange'
  },
  initialize: function initialize() {
    this.wasValid = this.model.get('isValid');
  },
  onDestroy: function onDestroy() {
    if (svs.components.marketplace && svs.components.marketplace.accountSelector && svs.components.marketplace.accountSelector.helpers) {
      svs.components.marketplace.accountSelector.helpers.observer.unsubscribe(this.marketplaceTag);
    }
  },
  marketplaceTag: function marketplaceTag(_ref) {
    var currentAccount = _ref.currentAccount;

    if (currentAccount && svs.maltipset.views.betslip) {
      if (svs.core.detect.feature('ft-betslip-maltipset')) {
        svs.maltipset.views.coupon.getRegion('betslip').currentView.showBetslipTag(currentAccount.name);
      } else {
        svs.maltipset.app.skeleton.getRegion('betslip').currentView.showBetslipTag(currentAccount.name);
      }
    } else {
      if (svs.core.detect.feature('ft-betslip-maltipset')) {
        svs.maltipset.views.coupon.getRegion('betslip').currentView.hideBetslipTag();
      } else {
        svs.maltipset.app.skeleton.getRegion('betslip').currentView.hideBetslipTag();
      }
    }
  },
  onChange: function onChange() {
    this.render();

    if (!this.wasValid && this.model.get('isValid')) {
      if (!svs.core.detect.feature('ft-betslip-maltipset')) {
        svs.maltipset.app.skeleton.getRegion('betslip').currentView.validBetslip();
      }
    }

    this.wasValid = this.model.get('isValid');
  },
  onRender: function onRender() {
    var marketplace = svs.components.marketplace;

    if (marketplace && marketplace.accountSelector) {
      var account = marketplace.accountSelector.helpers.getCurrentAccount();

      if (account) {
        if (svs.core.detect.feature('ft-betslip-maltipset') && !svs.core.detect.formfactor.mobile() && svs.maltipset.views.betslip) {
          svs.maltipset.views.coupon.getRegion('betslip').currentView.showBetslipTag(marketplace.accountSelector.helpers.getCurrentAccount().name);
        } else {
          svs.maltipset.app.skeleton.getRegion('betslip').currentView.showBetslipTag(marketplace.accountSelector.helpers.getCurrentAccount().name);
        }
      } else if (svs.components.marketplace.accountSelector.helpers) {
        svs.components.marketplace.accountSelector.helpers.observer.subscribe(this.marketplaceTag);

        if (svs.core.detect.feature('ft-betslip-maltipset') && !svs.core.detect.formfactor.mobile() && svs.maltipset.views.betslip) {
          svs.maltipset.views.coupon.getRegion('betslip').currentView.hideBetslipTag();
        } else {
          svs.maltipset.app.skeleton.getRegion('betslip').currentView.hideBetslipTag();
        }
      } else {
        if (svs.core.detect.feature('ft-betslip-maltipset') && !svs.core.detect.formfactor.mobile() && svs.maltipset.views.betslip) {
          svs.maltipset.views.coupon.getRegion('betslip').currentView.hideBetslipTag();
        } else {
          svs.maltipset.app.skeleton.getRegion('betslip').currentView.hideBetslipTag();
        }
      }
    } else {
      if (svs.core.detect.feature('ft-betslip-maltipset') && !svs.core.detect.formfactor.mobile() && svs.maltipset.views.betslip) {
        svs.maltipset.views.coupon.getRegion('betslip').currentView.hideBetslipTag();
      } else {
        svs.maltipset.app.skeleton.getRegion('betslip').currentView.hideBetslipTag();
      }
    }
  }
});
 })(window);